import React from 'react'

const Face = () => {
  return (
    <svg
      id='Face_icon'
      data-name='Face icon'
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='52'
      viewBox='0 0 52 52'
    >
      <g id='Face-ID'>
        <g id='Group_8199' data-name='Group 8199'>
          <g id='Group_8198' data-name='Group 8198'>
            <g id='Corners'>
              <g id='Corner'>
                <path
                  id='Path_9830'
                  data-name='Path 9830'
                  d='M2.674,14.263V8.469A5.7,5.7,0,0,1,8.469,2.674h5.794a1.337,1.337,0,0,0,0-2.674H8.469A8.377,8.377,0,0,0,0,8.469v5.794a1.337,1.337,0,0,0,2.674,0Z'
                  fill='rgba(255,255,255,0.47)'
                />
              </g>
              <g id='Corner-2' data-name='Corner' transform='translate(52 15.6) rotate(180)'>
                <path
                  id='Path_9831'
                  data-name='Path 9831'
                  d='M2.674,1.337V7.131a5.7,5.7,0,0,0,5.794,5.794h5.794a1.337,1.337,0,0,1,0,2.674H8.469A8.377,8.377,0,0,1,0,7.131V1.337a1.337,1.337,0,0,1,2.674,0Z'
                  fill='rgba(255,255,255,0.47)'
                />
              </g>
              <g id='Corner-3' data-name='Corner' transform='translate(0 36.4)'>
                <path
                  id='Path_9832'
                  data-name='Path 9832'
                  d='M2.674-22.663v5.794a5.7,5.7,0,0,0,5.794,5.794h5.794A1.337,1.337,0,0,1,15.6-9.737,1.337,1.337,0,0,1,14.263-8.4H8.469A8.377,8.377,0,0,1,0-16.869v-5.794A1.337,1.337,0,0,1,1.337-24,1.337,1.337,0,0,1,2.674-22.663Z'
                  transform='translate(0 24)'
                  fill='rgba(255,255,255,0.47)'
                />
              </g>
              <g id='Corner-4' data-name='Corner' transform='translate(52 52) rotate(180)'>
                <path
                  id='Path_9833'
                  data-name='Path 9833'
                  d='M2.674,14.263V8.469A5.7,5.7,0,0,1,8.469,2.674h5.794a1.337,1.337,0,0,0,0-2.674H8.469A8.377,8.377,0,0,0,0,8.469v5.794a1.337,1.337,0,0,0,2.674,0Z'
                  fill='rgba(255,255,255,0.47)'
                />
              </g>
            </g>
            <g id='Eye' transform='translate(14.14 18.246)'>
              <path
                id='Path'
                d='M0,1.393V5.109A1.349,1.349,0,0,0,1.3,6.5,1.349,1.349,0,0,0,2.6,5.109V1.393A1.349,1.349,0,0,0,1.3,0,1.349,1.349,0,0,0,0,1.393Z'
                fill='rgba(255,255,255,0.47)'
              />
            </g>
            <g id='Eye-2' data-name='Eye' transform='translate(35.579 18.246)'>
              <path
                id='Path-2'
                data-name='Path'
                d='M0,1.393V5.109A1.349,1.349,0,0,0,1.3,6.5,1.349,1.349,0,0,0,2.6,5.109V1.393A1.349,1.349,0,0,0,1.3,0,1.349,1.349,0,0,0,0,1.393Z'
                fill='rgba(255,255,255,0.47)'
              />
            </g>
            <path
              id='Mouth'
              d='M25.7,57.807a12.977,12.977,0,0,0,9.144,3.561,12.977,12.977,0,0,0,9.144-3.561,1.368,1.368,0,0,0-1.867-2,10.244,10.244,0,0,1-7.277,2.825,10.244,10.244,0,0,1-7.277-2.825,1.368,1.368,0,1,0-1.867,2Z'
              transform='translate(-8.842 -19.404)'
              fill='rgba(255,255,255,0.47)'
            />
            <path
              id='Nose'
              d='M38.281,29.439v9.579a.8.8,0,0,1-.916.912h-.909a1.368,1.368,0,1,0,0,2.737h.909a3.519,3.519,0,0,0,3.652-3.649V29.439a1.368,1.368,0,0,0-2.737,0Z'
              transform='translate(-12.281 -9.825)'
              fill='rgba(255,255,255,0.47)'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Face
